import React from 'react'
import { Trash2 } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

// ButtonWithIcon pinta `svg { fill }`; el estilo en línea lo anula para que el icono quede sólo con trazo.
const icon = ({ style, ...props }) => (
  <Trash2 size={18} color={tokens.color.error.main} style={{ fill: 'none', ...style }} {...props} />
)

export default icon
